import React, { useEffect, useState } from "react";
import config, { getBasicAuthHeaders } from "utils/configAdapter";
import { connect } from "react-redux";
import * as Icons from "@ant-design/icons";
import { mask, getColumnSearchProps } from "utils/helpers";
import dayjs from "dayjs";
import "dayjs/locale/pt-br";
import customParseFormat from "dayjs/plugin/customParseFormat";
import Core from "../../../../class/Core.js";
import {
    DatePicker,
    Row,
    Col,
    Form,
    Input,
    Table,
    Button,
    Select,
    message,
    Spin,
    Divider,
    Typography,
    Card,
} from "antd";
import ptBR from "antd/es/date-picker/locale/pt_BR";

import "./adicionaisstyle.scss";

dayjs.extend(customParseFormat);
dayjs.locale("pt-br");

// Removed: const _initToken = localStorage.getItem("authUser")

const EmpresaAdesaoLogs = (props) => {
    const sizePage = 10;
    const { RangePicker } = DatePicker;
    const [total, setTotal] = useState(0);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(sizePage);
    const [loading, setLoading] = useState(false);
    const [dataSource, setDataSource] = useState([]);
    const [dataIni, setDataIni] = useState("");
    const [dataFim, setDataFim] = useState("");
    const [adic, setAdic] = useState([]);
    const [paramsEXCEL, setParamsEXCEL] = useState("");

    const [form] = Form.useForm();
    const FormItem = Form.Item;
    const { Title, Text } = Typography;

    useEffect(() => {
        getAdicList();
        if (window.location.search) {
            const URLparams = Object.fromEntries(
                new URLSearchParams(window.location.search),
            );
            if (URLparams.adic) {
                URLparams.blto_adic = URLparams.adic;
            }
            if (URLparams.s) {
                URLparams.empresa_pesquisa = URLparams.s;
            }
            const params = { tipo: "sim", ...URLparams };
            form.setFieldsValue(params);
            if (Object.keys(URLparams).length) callSearchForm(params);
        }
    }, []);

    const getAdicList = async () => {
        try {
            let core = new Core();
            let user = core.getAuth();

            let params = "?usuario=" + user.key;

            let result = await fetch(
                config[process.env.NODE_ENV].url +
                    `/empresa/relatorios/helper/adicional_list${params}`,
                {
                    method: "GET",
                    headers: getBasicAuthHeaders(),
                },
            );

            if (!result.ok) {
                throw await result.json();
            }

            result = await result.json();

            if (result.content) {
                result = result.content.map((e) => {
                    return {
                        value: `${e.id_adic}`,
                        label: `${e.nome_adic}`,
                    };
                });
            }

            setAdic(result);
        } catch (e) {
            message.error(e?.message || "Erro ao carregar adicionais.");
        }
    };

    const callSearchForm = async (data) => {
        try {
            if (data === null) {
                data = form.getFieldsValue();
            }

            let params = JSON.parse(JSON.stringify(data));

            params.dataIni = dataIni;
            params.dataFim = dataFim;
            params.page = page;
            params.pageSize = pageSize;
            params.pagos = "SIM";

            let searchParams = new URLSearchParams(params);
            searchParams = searchParams.toString();
            setParamsEXCEL(searchParams);

            setLoading(true);

            let result = await fetch(
                config[process.env.NODE_ENV].url +
                    `/adicionais/relatorios/empresas-adesao?${searchParams}`,
                {
                    method: "GET",
                    headers: new Headers(getBasicAuthHeaders()),
                },
            );

            if (!result.ok) {
                throw await result.json();
            }

            result = await result.json();

            setDataSource(result.content);

            if (result.total) {
                setTotal(result.total);
            }
        } catch (e) {
            message.error(e?.message || "Erro ao buscar dados.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (total > 0) {
            callSearchForm(null);
        }
    }, [page, pageSize]);

    const limparBuscar = () => {
        form.resetFields();
        setTotal(0);
        setPage(1);
        setPageSize(sizePage);
        setDataSource([]);
        setDataIni("");
        setDataFim("");
        setParamsEXCEL("");
    };

    const formSearch = () => {
        return (
            <Form layout="vertical" form={form}>
                <Row gutter={5}>
                    {/* ROW */}
                    <Col sm={24} md={7} lg={6}>
                        <FormItem
                            name="blto_adic"
                            label="Adicional"
                            rules={[
                                {
                                    required: true,
                                    message:
                                        "Por favor, selecione um adicional!",
                                },
                            ]}
                        >
                            <Select
                                placeholder="Selecione"
                                showSearch
                                filterOption={(input, option) =>
                                    (
                                        option?.value + option?.label ?? ""
                                    ).includes(input.toUpperCase())
                                }
                                options={adic}
                            />
                        </FormItem>
                    </Col>

                    <Col sm={24} md={6} lg={5}>
                        <FormItem
                            name="periodo"
                            label="Selecione um Período do Aceite"
                        >
                            <RangePicker
                                style={{
                                    width: "100%",
                                    height: 36,
                                }}
                                locale={ptBR}
                                format={"DD/MM/YYYY"}
                                disabledDate={(current) => {
                                    return (
                                        current &&
                                        current > dayjs().endOf("day")
                                    );
                                }}
                                onChange={(dates, datesString) => {
                                    if (dates && dates.length === 2) {
                                        setDataIni(
                                            dates[0].format("YYYY-MM-DD"),
                                        );
                                        setDataFim(
                                            dates[1].format("YYYY-MM-DD"),
                                        );
                                    } else {
                                        setDataIni("");
                                        setDataFim("");
                                    }
                                }}
                            />
                        </FormItem>
                    </Col>

                    {/* ROW */}

                    <Col sm={24} md={24} lg={24} align="left">
                        <div style={{ marginTop: 55, display: "inline-block" }}>
                            {paramsEXCEL ? (
                                <a
                                    style={{ paddingRight: "10px" }}
                                    href={`${
                                        config[process.env.NODE_ENV].url
                                    }/adicionais/relatorios/empresas-adesao?${paramsEXCEL}&excel=true`}
                                    download
                                    onClick={(e) =>
                                        loading && e.preventDefault()
                                    }
                                >
                                    <Button type="default" disabled={loading}>
                                        Download XLSX
                                    </Button>
                                </a>
                            ) : null}
                            <Button
                                type="ghost"
                                onClick={() => limparBuscar()}
                                style={{ marginRight: 8 }}
                                disabled={loading}
                            >
                                Limpar Busca
                            </Button>
                            <Button
                                type="primary"
                                style={{
                                    backgroundColor: "#52c41a",
                                    borderColor: "#52c41a",
                                    marginRight: 8,
                                }}
                                onClick={async () => {
                                    try {
                                        await form.validateFields([
                                            "blto_adic",
                                        ]);
                                        if (page !== 1) {
                                            setPage(1);
                                        }
                                        const values = form.getFieldsValue();
                                        callSearchForm({
                                            ...values,
                                            tipo: "SIM",
                                        });
                                    } catch (error) {
                                        // Validação falhou, mensagem já exibida pelo Form
                                    }
                                }}
                                disabled={loading}
                                loading={loading}
                            >
                                ADERIU
                            </Button>
                            <Button
                                type="primary"
                                danger
                                onClick={async () => {
                                    try {
                                        await form.validateFields([
                                            "blto_adic",
                                        ]);
                                        if (page !== 1) {
                                            setPage(1);
                                        }
                                        const values = form.getFieldsValue();
                                        callSearchForm({
                                            ...values,
                                            tipo: "NAO",
                                        });
                                    } catch (error) {
                                        // Validação falhou, mensagem já exibida pelo Form
                                    }
                                }}
                                disabled={loading}
                                loading={loading}
                            >
                                NÃO ADERIU
                            </Button>
                        </div>
                    </Col>
                </Row>
            </Form>
        );
    };

    const columns = [
        {
            title: <small>CNPJ/CPF</small>,
            dataIndex: "cnpj_empr",
            key: "cnpj",
            width: 155,
            sorter: (a, b) => a.cnpj_empr - b.cnpj_empr,
            ...getColumnSearchProps("cnpj_empr", "number"),
            render: (data) => (
                <Typography.Text
                    copyable={{
                        text: data,
                        icon: [<Icons.CopyFilled />, <Icons.CopyOutlined />],
                        tooltips: ["Copiar", "Copiado!"],
                    }}
                >
                    {mask(data)}
                </Typography.Text>
            ),
        },
        {
            title: <small>Empregador</small>,
            dataIndex: "razao_empr",
            key: "razao",
            ...getColumnSearchProps("razao_empr"),
            sorter: (a, b) =>
                a.razao_empr.trim().localeCompare(b.razao_empr.trim()),
        },
        {
            title: <small>ID Cob.</small>,
            dataIndex: "id_empr_blto",
            key: "id_empr_blto",
            width: 100,
        },
        {
            title: <small>Blto. Pago</small>,
            dataIndex: "fl_pago_empr_blto",
            key: "fl_pago_empr_blto",
            width: 100,
            render: (vl) => (vl ? "SIM" : "NÃO"),
        },
        {
            title: (
                <small>
                    Data
                    <br />
                    Vencimento
                </small>
            ),
            dataIndex: "dt_vcto_empr_blto",
            key: "venc_boleto",
            width: 100,
            ...getColumnSearchProps("dt_vcto_empr_blto", "RangePicker"),
            sorter: (a, b) =>
                dayjs(a.dt_vcto_empr_blto).valueOf() -
                dayjs(b.dt_vcto_empr_blto).valueOf(),
            render: (data) => (data ? mask(data, "date") : "-"),
        },
        {
            title: <small>ACEITE</small>,
            dataIndex: "aceite_empr_adic_adesao",
            key: "aceite_empr_adic_adesao",
            width: 60,
            render: (data) => (data === "SIM" ? "SIM" : "NÃO"),
        },
        {
            title: <small>Data do Aceite</small>,
            dataIndex: "dt_frt_empr_adic_adesao",
            key: "dt_frt_empr_adic_adesao",
            width: 100,
            render: (data) =>
                data ? dayjs(data).format("DD/MM/YYYY HH:mm:ss") : "",
        },
        {
            title: <small>Plano</small>,
            dataIndex: "id_tr_plno",
            key: "id_tr_plno",
            width: 50,
        },
        {
            title: <small>Usuário</small>,
            key: "usuario_login",
            width: 300,
            render: (data) => {
                const body = data.body_empr_adic_adesao;
                if (body?.operador) {
                    return (
                        <ul>
                            <li>
                                <strong>CPF</strong>: {body.operador.cpf}
                            </li>
                            <li>
                                <strong>NOME</strong>: {body.operador.nome}
                            </li>
                        </ul>
                    );
                }
                return "";
            },
        },
    ];

    const tableContent = () => {
        return (
            <Row>
                <Col sm={24} md={24} lg={24}>
                    <Table
                        rowKey={"id_empr_adic_adesao"}
                        columns={columns}
                        scroll={{ x: 400 }}
                        dataSource={dataSource}
                        pagination={{
                            showTotal: () => (
                                <span>
                                    Total <b>{total}</b> registro(s)
                                </span>
                            ),
                            total: total,
                            pageSize: pageSize,
                            current: page,
                            showSizeChanger: true,
                            pageSizeOptions: [20, 50, 100],
                            onChange: (dPage, dSize) => {
                                setPage(dPage);
                                if (pageSize !== dSize) {
                                    setPageSize(dSize);
                                }
                            },
                        }}
                    />
                </Col>
            </Row>
        );
    };

    return (
        <>
            <Card
                style={{ marginBottom: 24 }}
                bodyStyle={{ padding: "20px 24px" }}
            >
                <Row align="middle" justify="space-between">
                    <Col>
                        <Title
                            level={2}
                            style={{ margin: 0, color: "#1890ff" }}
                        >
                            <Icons.FileTextOutlined
                                style={{ marginRight: 8 }}
                            />
                            Logs de Adesão de Empregadores
                        </Title>
                        <Text type="secondary" style={{ fontSize: "14px" }}>
                            Histórico completo de adesões dos empregadores aos
                            adicionais, incluindo data do aceite, usuário
                            responsável e informações de pagamento.
                        </Text>
                    </Col>
                </Row>
            </Card>

            <Spin spinning={loading}>
                {formSearch()}

                <Divider />

                {tableContent()}
            </Spin>
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        user: state.user,
    };
};

export default connect(mapStateToProps)(EmpresaAdesaoLogs);
